import type { ClientInsuranceCampaignForAdmin } from '@/general/src/insuranceCampaign/backend.js'
import { personalKaskoInsuranceScenarioResultColumns } from '@/general/src/insuranceScenario/personalKasko/webapp.js'
import { personalOsagoInsuranceScenarioResultColumns } from '@/general/src/insuranceScenario/personalOsago/webapp.js'
import type { InsuranceType } from '@/general/src/insuranceType/shared.js'

export type InsuranceScenarioResultColumn = {
  heading: string
  width: number
  key: string
  body: (record: ClientInsuranceCampaignForAdmin['insuranceScenariosInfos'][number]) => React.ReactNode
}

export const getInsuranceScenarioResultColumns = ({
  insuranceType,
}: {
  insuranceType: InsuranceType
}): InsuranceScenarioResultColumn[] => {
  return {
    personalOsago: personalOsagoInsuranceScenarioResultColumns,
    personalKasko: personalKaskoInsuranceScenarioResultColumns,
  }[insuranceType]
}
